// extracted by mini-css-extract-plugin
export default {"container":"NU-z","title":"OU-z","link":"PU-z"};